module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8447a900a52e87d717ddeda4280434c1.png";